export const getLocale = ({
  locale: { language, country } = { language: 'en', country: 'US' },
}) => [language, country].filter((_) => !!_).join('-');
